import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as store from '../state';
import * as commonActions from './common.action';
import {
    getPostListLoading,
    getPostListData,
    getPostListFailData,
    getPostListDataAmount,
    getPostItemLoading,
    getPostItemData,
    getPostItemFailData,
    removePostItemLoading,
    removePostItemData,
    removePostItemFailData,
    createPostItemLoading,
    createPostItemData,
    createPostItemFailData,
    updatePostItemLoading,
    updatePostItemData,
    updatePostItemFailData,
    getCategoryItemLoading,
    getCategoryItemData,
    getCategoryItemFailData,
    getCategoryListData,
    getCategoryListLoading,
    getCategoryListFailData,
    createTagItemLoading,
    createTagItemData,
    createTagItemFailData,
    updateTagItemLoading,
    updateTagItemData,
    updateTagItemFailData,
    removeTagItemLoading,
    removeTagItemData,
    removeTagItemFailData,
    getTagItemLoading,
    getTagItemData,
    getTagItemFailData,
    getTagListLoading,
    getTagListData,
    getTagListFailData,
    removeImageFromPostLoading,
    removeImageFromPostData,
    removeImageFromPostFailData
} from './common.selector';

@Injectable()
export class CommonSandbox {
    public getPostListLoading$ = this.appState$.select(getPostListLoading);
    public getPostListData$ = this.appState$.select(getPostListData);
    public getPostListFailData$ = this.appState$.select(getPostListFailData);
    public getPostListDataAmount$ = this.appState$.select(getPostListDataAmount);

    public getPostItemLoading$ = this.appState$.select(getPostItemLoading);
    public getPostItemData$ = this.appState$.select(getPostItemData);
    public getPostItemFailData$ = this.appState$.select(getPostItemFailData);

    public removePostItemLoading$ = this.appState$.select(removePostItemLoading);
    public removePostItemData$ = this.appState$.select(removePostItemData);
    public removePostItemFailData$ = this.appState$.select(removePostItemFailData);

    public createPostItemLoading$ = this.appState$.select(createPostItemLoading);
    public createPostItemData$ = this.appState$.select(createPostItemData);
    public createPostItemFailData$ = this.appState$.select(createPostItemFailData);

    public updatePostItemLoading$ = this.appState$.select(updatePostItemLoading);
    public updatePostItemFailData$ = this.appState$.select(updatePostItemFailData);
    public updatePostItemData$ = this.appState$.select(updatePostItemData);

    public getCategoryItemLoading$ = this.appState$.select(getCategoryItemLoading);
    public getCategoryItemData$ = this.appState$.select(getCategoryItemData);
    public getCategoryItemFailData$ = this.appState$.select(getCategoryItemFailData);

    public getCategoryListData$ = this.appState$.select(getCategoryListData);
    public getCategoryListLoading$ = this.appState$.select(getCategoryListLoading);
    public getCategoryListFailData$ = this.appState$.select(getCategoryListFailData);

    public createTagItemLoading$ = this.appState$.select(createTagItemLoading);
    public createTagItemData$ = this.appState$.select(createTagItemData);
    public createTagItemFailData$ = this.appState$.select(createTagItemFailData);

    public updateTagItemLoading$ = this.appState$.select(updateTagItemLoading);
    public updateTagItemData$ = this.appState$.select(updateTagItemData);
    public updateTagItemFailData$ = this.appState$.select(updateTagItemFailData);

    public removeTagItemLoading$ = this.appState$.select(removeTagItemLoading);
    public removeTagItemData$ = this.appState$.select(removeTagItemData);
    public removeTagItemFailData$ = this.appState$.select(removeTagItemFailData);

    public getTagItemLoading$ = this.appState$.select(getTagItemLoading);
    public getTagItemData$ = this.appState$.select(getTagItemData);
    public getTagItemFailData$ = this.appState$.select(getTagItemFailData);

    public getTagListLoading$ = this.appState$.select(getTagListLoading);
    public getTagListData$ = this.appState$.select(getTagListData);
    public getTagListFailData$ = this.appState$.select(getTagListFailData);

    public removeImageFromPostLoading$ = this.appState$.select(removeImageFromPostLoading);
    public removeImageFromPostData$ = this.appState$.select(removeImageFromPostData);
    public removeImageFromPostFailData$ = this.appState$.select(removeImageFromPostFailData);

    constructor(protected appState$: Store<store.AppState>) { }

    doGetPostsList(params: any): void {
        this.appState$.dispatch(new commonActions.GetPostListAction(params));
    }

    doGetPostItem(params: any): void {
        this.appState$.dispatch(new commonActions.GetPostItemAction(params));
    }
    doClearGetPostItemState(): void {
        this.appState$.dispatch(new commonActions.ClearGetPostItemStateAction({}));
    }

    doRemovePostItem(params: any): void {
        this.appState$.dispatch(new commonActions.RemovePostItemAction(params));
    }
    doClearRemovePostItemState(): void {
        this.appState$.dispatch(new commonActions.ClearRemovePostItemStateAction({}));
    }
    doCreatePostItem(params: any): void {
        this.appState$.dispatch(new commonActions.CreatePostItemAction(params));
    }
    doClearCreatePostItemState(): void {
        this.appState$.dispatch(new commonActions.ClearCreatePostItemStateAction({}));
    }
    doUpdatePostItem(params: any): void {
        this.appState$.dispatch(new commonActions.UpdatePostItemAction(params));
    }
    doClearUpdatePostItemState(): void {
        this.appState$.dispatch(new commonActions.ClearUpdatePostItemStateAction({}));
    }
    doGetCategoryList(params: any): void {
        this.appState$.dispatch(new commonActions.GetCategoryListAction(params));
    }
    doGetCategoryItem(id: number): void {
        this.appState$.dispatch(new commonActions.GetCategoryItemAction({ id: id }));
    }
    doClearGetCategoryItemState(): void {
        this.appState$.dispatch(new commonActions.ClearGetCategoryItemStateAction({}));
    }

    doCreateTagItem(params: any): void {
        this.appState$.dispatch(new commonActions.CreateTagItemAction(params));
    }
    doClearCreateTagItemState(): void {
        this.appState$.dispatch(new commonActions.ClearCreateTagItemStateAction({}));
    }

    doUpdateTagItem(id: number, params: any): void {
        this.appState$.dispatch(new commonActions.UpdateTagItemAction({ id: id, params: params }));
    }
    doClearUpdateTagItemState(): void {
        this.appState$.dispatch(new commonActions.ClearUpdateTagItemStateAction({}));
    }

    doRemoveTagItem(id: number): void {
        this.appState$.dispatch(new commonActions.RemoveTagItemAction({ id: id }));
    }
    doClearRemoveTagItemState(): void {
        this.appState$.dispatch(new commonActions.ClearRemoveTagItemStateAction({}));
    }

    doGetTagItem(id: number): void {
        this.appState$.dispatch(new commonActions.GetTagItemAction({ id: id }));
    }
    doClearGetTagItemState(): void {
        this.appState$.dispatch(new commonActions.ClearGetTagItemStateAction({}));
    }

    doGetTagList(params: any): void {
        this.appState$.dispatch(new commonActions.GetTagListAction(params));
    }

    doRemoveImageFromPost(id: string | number): void {
        this.appState$.dispatch(new commonActions.RemoveImageFromPostAction(id));
    }
    doClearRemoveImageFromPostState(): void {
        this.appState$.dispatch(new commonActions.ClearRemoveImageFromPostStateAction({}));
    }
}
